module.exports = __webpack_public_path__ + "img/LoginLogoC5.15.9cfb052c.svg";